import { resetPasswordByLinkRequestPayload } from "@/data/payload/auth/change-password-by-link-request-payload";
import { UserPasswordManageRepository } from "@/domain/repository/user-password-reset-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class ResetPasswordByLinkUsecase {
  //MARK:- init
  constructor(private readonly userPasswordManageRepository: UserPasswordManageRepository) {}

  //MARK:- execute
  async execute(
    token: string,
    newPassword: string,
    confirmPassword: string
  ): Promise<SATResult<void, SATError>> {
    const payload: resetPasswordByLinkRequestPayload = {
      token: token,
      newSn: confirmPassword,
    };

    const result = await this.userPasswordManageRepository.resetPasswordByLink(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return SATResult.success(void 0);
  }
}
